import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
export const Route = createFileRoute("/events/mine")({
  component: lazyRouteComponent(
    () => import("@/pages/EventsPage"),
    "MyEventsPage",
  ),
});
